import React, { useState, useMemo } from 'react';
import * as PR from "../prime-modules/index";
import { Link } from "react-router-dom";
import { forgotPassword } from "../services/api";
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useFormik } from "formik";
import { useToast } from "../context/ToastContext";

const ForgotPassword = (props) => {
    const {labels, validations, showToast} = useToast()
    const dispatch = useDispatch();
    const [disableBtn, setDisableBtn] = useState(false);
    const affiliatePath = useSelector(state => state.auth.affiliatePath);
    const affiliateTrackingData = useSelector(state => state.affiliateTracking.affiliateTrackingInfo ? state.affiliateTracking.affiliateTrackingInfo : affiliatePath?.afid);
    const headers = useMemo(() => {
        return { afid: affiliateTrackingData };
    }, [affiliateTrackingData]);

    const validationSchema = () => {
        return Yup.object().shape({
            email: Yup.string()
                .trim()
                .email(validations?.VLD0006)
                .required(validations?.VLD0005),
        });
    }
    const submitHandler = (formData) => {
        setDisableBtn(true);
        const getResponse = (response) => {
            if (response.result === "SUCCESS") {
                showToast("success",labels?.LBL0287)
                formik.resetForm();
            } else {
                const error = response.error;
                const errorMsg = (error.errorMsg) ? error.errorMsg : error.summary;
                showToast("error",errorMsg)
            }
            setDisableBtn(false);
        }
        const emailVal = formData.email.trim();
        forgotPassword(`forgotpassword?email=${emailVal}`, headers, dispatch, getResponse)
    }
    const formik = useFormik({
        initialValues: { email: "" },
        validationSchema: validationSchema,
        onSubmit: submitHandler
    });
    return (
        <>
            <div className="form-section forgot-password-section">
                <div className="form">
                    <h3>{labels?.LBL0033}</h3>
                    <p>{labels?.LBL0305}</p>
                    <form onSubmit={formik.handleSubmit} autoComplete="off">
                    <div className="input-field">
                        <PR.InputText id="email" name="email" placeholder={labels?.LBL0037} className="w-12" value={formik.values.email} onChange={formik.handleChange} onBlur={formik.handleBlur} autoComplete="off" />
                        {formik.errors.email && formik.touched.email ? <div className='error-message'>{formik.errors.email}</div> : ''}
                    </div>
                    <PR.Button label={labels?.LBL0035} type='submit' disabled={disableBtn} className="login-btn signup-btn" />
                    <div className="text-center mt-5 px-6"><p>{labels?.LBL0036} <Link onClick={() => props.renderFormState(true, 'signup')}>{labels?.LBL0038}</Link></p></div>
                    </form>
                </div>   
            </div>
        </>
    );
};

export default ForgotPassword;